import React from 'react'
import Text from '../../../atoms/text/Text'
import Card from '../../../atoms/card/Card'
import VerticalGroup from '../../../atoms/verticalgroup/VerticalGroup'
import '../RoundResults.scss'
import InlineGroup from '../../../atoms/inlinegroup/InlineGroup'

interface Props {
  currencyDenomination?: string
  heading: string
}

const ChartCard: React.FC<Props> = ({
  currencyDenomination,
  heading,
  children
}) => {

  return (
    <Card flex wide sharp>
      <VerticalGroup full center wide>
        <VerticalGroup full center wide>
          <Text size="4xl">{heading}</Text>
          {children}
        </VerticalGroup>
        <VerticalGroup wide>
          <InlineGroup right block className='pr-12' style={{ alignSelf: 'flex-end' }}><Text size='lg' bold>{currencyDenomination}&nbsp;</Text></InlineGroup>
        </VerticalGroup>
      </VerticalGroup>
    </Card>
  )
}

export default ChartCard